import { render, staticRenderFns } from "./CommentBubble.vue?vue&type=template&id=f7bd4b82&scoped=true&"
import script from "./CommentBubble.vue?vue&type=script&lang=js&"
export * from "./CommentBubble.vue?vue&type=script&lang=js&"
import style0 from "./CommentBubble.vue?vue&type=style&index=0&id=f7bd4b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd4b82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
